import { render, staticRenderFns } from "./headtabr.vue?vue&type=template&id=2c57417b&scoped=true&"
import script from "./headtabr.vue?vue&type=script&lang=js&"
export * from "./headtabr.vue?vue&type=script&lang=js&"
import style0 from "./headtabr.vue?vue&type=style&index=0&id=2c57417b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57417b",
  null
  
)

export default component.exports